import { useQuery } from "@tanstack/react-query"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { reportErrorMessage } from "#/utils/ErrorReporting"
import { getTalkToCarrotExpertGuidance } from "#/lib/contentful/contentfulClient"
import { EntryWithoutUnresolvableLinks } from "#/utils/ContentTypes"
import { TypePageGuidanceSkeleton } from "#/types/contentful"

const expertGuidanceQueryKey = "getExpertGuidance"

export function useGetExpertGuidance(locale: string) {
  return useQuery<EntryWithoutUnresolvableLinks<TypePageGuidanceSkeleton>, ResponseError>(
    [expertGuidanceQueryKey],
    () => getTalkToCarrotExpertGuidance(locale),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: buildCarrotApiRetryPolicy(3),
      onError: (error) => reportErrorMessage(`Failed to fetch landing page guidance with error: ${error}`)
    }
  )
}
